import React, { useState } from 'react';
import { format, parseISO, isValid } from 'date-fns';
import { es } from 'date-fns/locale';
import { CalendarIcon } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Calendar } from '@/components/ui/calendar';
import { Button } from '@/components/ui/button';

/** Single date picker (es-ES, dd/MM/yyyy) — same Calendar/Popover used by
 * GlobalFilterBar, replacing native <input type="date"> (31/08 backlog).
 * value/onChange work with 'yyyy-MM-dd' strings, same contract as before. */
export function DateField({ value, onChange, placeholder = 'Selecciona fecha', className = '', testId }) {
  const [open, setOpen] = useState(false);
  const parsed = value ? parseISO(value) : null;
  const displayValue = parsed && isValid(parsed) ? format(parsed, 'dd/MM/yyyy') : '';

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          type="button"
          className={`h-8 text-xs justify-start font-normal gap-1.5 ${className}`}
          style={{ background: 'var(--vz-bg-elevated)', borderColor: 'var(--vz-border-subtle)', color: displayValue ? 'var(--vz-text-primary)' : 'var(--vz-text-muted)' }}
          data-testid={testId}
        >
          <CalendarIcon size={12} />
          {displayValue || placeholder}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" style={{ background: 'var(--vz-bg-card)', borderColor: 'var(--vz-border-subtle)', zIndex: 100 }}>
        <Calendar
          mode="single"
          locale={es}
          selected={parsed && isValid(parsed) ? parsed : undefined}
          onSelect={(d) => { if (d) { onChange(format(d, 'yyyy-MM-dd')); setOpen(false); } }}
        />
      </PopoverContent>
    </Popover>
  );
}
